import { Box, Button, Grid, Typography } from "@mui/material"
import useAuth from "../../context/auth"
import { useEffect, useState } from "react"
import { LoadingButton } from "@mui/lab"
import { Format } from "../../utils"
import { useNavigate } from "react-router-dom"
import { SelectPIXModal } from "../simulator/modal/pix"
import { PartnerService } from "../../services/partner"


export const PartnerDashboard = () => {
    const { user, isMobile, handleModal, getData } = useAuth()
    const [copied, setCopied] = useState(false)
    const [loading, setLoading] = useState(false)
    const [openPIX, setOpenPIX] = useState(false)

    const navigate = useNavigate()

    useEffect(() => {
        if (copied) {
            setTimeout(() => {
                setCopied(false)
            }, 3000);
        }
    }, [copied])

    const withdraw = (to: "cpf" | "cnpj") => {
        setLoading(true)
        PartnerService.withdraw({
            accountId: user?.account?.id as number,
            toKey: to,
            // value: 0.01
        })
            .then(() => {
                handleModal(true, {
                    message: "Sua solicitação de saque foi efetuada com sucesso!",
                    type: "success"
                })
            })
            .finally(() => {
                setLoading(false)
                getData()

            })
    }

    return (
        <Box
            sx={{
                maxWidth: "150rem",
                width: "100%",
                margin: "0 auto",
                ...(!isMobile && {
                    padding: "0 2rem",
                    boxSizing: "border-box"
                }),
            }}
        >
            <Grid
                sx={{
                    width: "100%",
                    height: "100%",
                }}
            >
                <Typography color="secondary" fontWeight={900} fontSize={"2.8rem"} mb={"2rem"}>Olá, {user?.name?.split(" ")[0]}</Typography>

                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    gap={"2rem"}
                    justifyContent={"space-between"}
                    padding={"2rem 1rem"}
                    boxSizing={"border-box"}
                    width={"100%"}
                    sx={{
                        backgroundColor: "#FFFFFF",
                        borderRadius: "10px"
                    }}
                >
                    <Grid
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <Typography fontSize={"1.6rem"} fontWeight={400} color="#49454F">Comissão disponível</Typography>
                        <Typography fontSize={"3.2rem"} lineHeight={"3.5rem"} fontWeight={900} color="#49B84F">{Format.currency(user?.account?.balance ?? 0)}</Typography>
                    </Grid>
                    <Grid
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        direction={"column"}
                        gap={".5rem"}
                    >
                        <LoadingButton
                            variant="contained"
                            sx={{
                                width: "11.1rem",
                                height: "3.5rem",
                                fontSize: "1.4rem"
                            }}
                            onClick={() => {
                                setOpenPIX(true)
                            }}
                            loading={loading}
                            disabled={(user?.account?.balance ?? 0) <= 0}

                        >
                            Sacar
                        </LoadingButton>
                        <Button
                            sx={{
                                width: "11.1rem",
                                height: "3.5rem",
                                fontSize: "1.4rem",
                                textDecoration: "underline",
                                color: "gray"
                            }}
                            onClick={() => navigate("/parceiro/extrato")}
                        >Ver extrato</Button>
                    </Grid>
                </Box>
                <SelectPIXModal
                    open={openPIX}
                    isCommission
                    onSelect={(value) => {
                        setOpenPIX(false)
                        withdraw(value)

                    }}
                    onClose={() => setOpenPIX(false)}
                />
            </Grid>
        </Box>
    )
}